/* eslint-disable no-alert */
import Vue from 'vue';
import FormDataService from 'services/form-data.service';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import AutoComplete from '../shared/AutoComplete.vue';
import Mappings from '../oil-sample/SampleDetail/OilSampleAutoCompleteMaps';
import FluidWeightConstants from '../../constants/column-name/fluid-weight.column-name.constants';

export default Vue.extend({
  name: 'FluidWeightAddEditForm',
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      mappings: Mappings
    };
  },
  computed: {
    formTitle() {
      return this.isEditMode ? 'Edit Fluid Weight' : 'Add Fluid Weight';
    }
  },
  mixins: [AddEditMixin],
  methods: {
    checkForm() {
      return this.checkFormSubmission({ FluidWeightConstants });
    },
    openDialog(data) {
      this.formData = {
        fluidWeightName: data?.fluidWeightName,
        fluidWeightID: data?.fluidWeightID,
        isActive: data?.isActive,
        isDeleted: data?.isDeleted
      };
      this.$nextTick(() => {
        this.$refs.addEditForm.openDialog(this.formData);
      });
    }
  },
  components: {
    AddEditForm,
    AutoComplete
  },
  beforeCreate() {
    // eslint-disable-next-line global-require
    this.$options.components.AutoComplete = require('../shared/AutoComplete.vue').default;
  },
  template: `
    <AddEditForm :title="formTitle" ref="addEditForm" @submit-button-clicked="onFormSubmit">
      ${FormDataService.textInput(FluidWeightConstants.fluidWeightName)}
    </AddEditForm>
  `
});
